import { Link } from 'found';
import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { createFragmentContainer, graphql } from 'react-relay';
import { ButtonGroup, ButtonToolbar } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';

import Loading from 'src/components/Loading';
import Address from 'src/components/Address';
import Breadcrumbs from 'src/enosikit/components/Breadcrumbs';
import Heading from 'src/enosikit/components/Heading';

import TradeRuleSetCommunityFlatForm from './TradeRuleSetCommunityFlatForm';

class TradeRuleSetCommunityFlat extends React.Component {
  renderPropertyControls = () => {
    const { property } = this.props;
    return (
      <ButtonToolbar>
        <ButtonGroup className="ms-2">
          <Link to={`/properties/${property.id}/trade-rules`} className="btn btn-darken">
            <FormattedMessage id="trade_rule.trade_rule_set_community_flat.all_trade_rules.label" defaultMessage="All trade rules" />
          </Link>
        </ButtonGroup>

        <ButtonGroup className="ms-2">
          <Link to={`/properties/${property.id}/settings`} className="btn btn-darken">
            <FormattedMessage id="trade_rule.trade_rule_set_community_flat.property_settings.label" defaultMessage="Property Settings" />
          </Link>
        </ButtonGroup>
      </ButtonToolbar>
    );
  };

  render() {
    if (this.error) {
      return <div><FormattedMessage id="error.title" defaultMessage="Error!" /></div>;
    }
    if (!this.props) {
      return <Loading />;
    }

    const {
      intl, property, meter, router,
    } = this.props;
    const { address, id, title } = property;
    const addr = new Address(address);
    const pageTitle = intl.formatMessage({
      id: 'trade_rule.trade_rule_set_community_flat.page_title',
      defaultMessage: 'Enosi - Property: {title} - Set community trade rules for {meterTitle}',
    }, { title, meterTitle: meter.title });

    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          {pageTitle}
        </Helmet>

        <Breadcrumbs
          breadcrumbs={[
            {
              name: <FormattedMessage id="trade_rule.trade_rule_set_community_flat.breadcrumbs.properties.label" defaultMessage="Properties" />, path: '/properties',
            },
            { name: title, path: `/properties/${id}` },
            { name: <FormattedMessage id="trade_rule.trade_rule_set_community_flat.breadcrumbs.trade_rules.label" defaultMessage="Trade Rules" />, path: `/properties/${id}/trade-rules/active` },
            {
              name: intl.formatMessage({
                id: 'trade_rule.trade_rule_set_community_flat.breadcrumbs.set_community_trade_rules.label',
                defaultMessage: 'Set community trade rules for {meterTitle}',
              }, { meterTitle: meter.title }),
            },
          ]}
        />
        <Heading
          alias={title}
          address={addr.simpleString()}
          context={<FormattedMessage id="trade_rule.trade_rule_set_community_flat.header.set_community_trade_rules.label" defaultMessage="Set community trade rules" />}
          controls={this.renderPropertyControls()}
        />
        <TradeRuleSetCommunityFlatForm property={property} meter={meter} router={router} />
      </>
    );
  }
}

TradeRuleSetCommunityFlat.propTypes = {
  property: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  meter: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  intl: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  relay: PropTypes.shape({
    refetch: PropTypes.func,
  }).isRequired,
  router: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types

};

TradeRuleSetCommunityFlat.defaultProps = {
  property: null,
  meter: null,
};

export default injectIntl(createFragmentContainer(
  TradeRuleSetCommunityFlat,
  {
    property: graphql`
      fragment TradeRuleSetCommunityFlat_property on Property {
        id
        title
        address {
          line1
          line2
          city
          state
          postcode
          gps {
            latitude
            longitude
          }
        }
        ...TradeRuleSetCommunityFlatForm_property
      }
    `,
    meter: graphql`
      fragment TradeRuleSetCommunityFlat_meter on Meter {
        id
        identifier
        title
        tradePointId
        ...TradeRuleSetCommunityFlatForm_meter
      }
    `,
  },
));
